<nz-layout cdkScrollable class="main-layout">
  <nz-content class="hide-scroollbar w-full">
    <router-outlet></router-outlet>
  </nz-content>
</nz-layout>
